import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import React from "react"
import { playerStore } from "src/store/PlayerStore"

import useTranslate from "../../../../hooks/use-translate"
import { s } from "../../../../utilities/common"
import { theme } from "../../../../utilities/theme"

export const ShuffleButton = ({ focusKey }: { focusKey?: string }) => {
  const t = useTranslate()
  const shuffle = playerStore((state) => state.shuffle)
  const setShuffle = playerStore((state) => state.setShuffle)

  const onPress = () => {
    setShuffle(!shuffle)
  }

  const { focused, ref, focusSelf } = useFocusable({
    focusKey,
    onEnterPress: onPress,
  })

  const isActive = shuffle
  const activeFocusedStroke =
    focused && isActive ? theme.palette.new.playerButton : "none"
  const activeFocusedStrokeWidth = focused && isActive ? 0.5 : 0

  return (
    <Box
      sx={{ height: s("72px"), width: s("72px") }}
      tabIndex={0}
      aria-label={`${t("player__button_repeat")}: ${shuffle ? t("settings_on") : t("settings_off")}`}
      onMouseEnter={() => focusSelf({ noScroll: true })}
      onMouseDown={onPress}
      ref={ref}
    >
      <svg
        width={s("72px")}
        height={s("72px")}
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="36"
          cy="36"
          r="36"
          fill={focused ? "white" : theme.palette.new.playerButton}
        />
        <path
          d="M19.2861 44.4805C19.2861 44.0605 19.4326 43.709 19.7256 43.4258C20.0283 43.1426 20.4092 43.001 20.8682 43.001H23.9883C24.7891 43.001 25.4727 42.8545 26.0391 42.5615C26.6055 42.2588 27.1865 41.751 27.7822 41.0381L36.1465 31.0039C37.0547 29.9199 37.9531 29.1777 38.8418 28.7773C39.7305 28.3672 40.8096 28.1621 42.0791 28.1621H44.7891V24.8955C44.7891 24.5342 44.8867 24.2559 45.082 24.0605C45.2871 23.8555 45.5703 23.7529 45.9316 23.7529C46.0879 23.7529 46.2393 23.7822 46.3857 23.8408C46.5322 23.8994 46.6592 23.9775 46.7666 24.0752L52.3037 28.7041C52.5771 28.9385 52.7139 29.2119 52.7139 29.5244C52.7139 29.8369 52.5771 30.1104 52.3037 30.3447L46.7666 34.959C46.6592 35.0664 46.5322 35.1494 46.3857 35.208C46.2393 35.2568 46.0879 35.2812 45.9316 35.2812C45.5703 35.2812 45.2871 35.1836 45.082 34.9883C44.8867 34.7832 44.7891 34.5 44.7891 34.1387V31.1064H42.0205C41.4736 31.1064 40.9902 31.1748 40.5703 31.3115C40.1504 31.4385 39.75 31.6436 39.3691 31.9268C38.998 32.21 38.6123 32.5908 38.2119 33.0693L29.6279 43.3232C28.8174 44.2803 28.0068 44.9639 27.1963 45.374C26.3857 45.7744 25.375 45.9746 24.1641 45.9746H20.8682C20.4092 45.9746 20.0283 45.833 19.7256 45.5498C19.4326 45.2666 19.2861 44.9102 19.2861 44.4805ZM19.2861 29.6416C19.2861 29.2021 19.4326 28.8457 19.7256 28.5723C20.0283 28.2988 20.4092 28.1621 20.8682 28.1621H24.0322C25.2432 28.1621 26.2734 28.3623 27.123 28.7627C27.9824 29.1631 28.8174 29.8418 29.6279 30.7988L38.1973 41.0234C38.793 41.7363 39.3887 42.249 39.9844 42.5615C40.5801 42.8643 41.2979 43.0156 42.1377 43.0156H44.7891V40.0273C44.7891 39.666 44.8867 39.3877 45.082 39.1924C45.2871 38.9971 45.5703 38.8994 45.9316 38.8994C46.0879 38.8994 46.2393 38.9287 46.3857 38.9873C46.5322 39.0361 46.6592 39.1094 46.7666 39.207L52.3037 43.8359C52.5771 44.0703 52.7139 44.3486 52.7139 44.6709C52.7139 44.9834 52.5771 45.252 52.3037 45.4766L46.7666 50.1055C46.6592 50.1934 46.5322 50.2617 46.3857 50.3105C46.2393 50.3691 46.0879 50.3984 45.9316 50.3984C45.5703 50.3984 45.2871 50.3008 45.082 50.1055C44.8867 49.9102 44.7891 49.6318 44.7891 49.2705V45.9746H42.0645C40.8535 45.9746 39.7939 45.7744 38.8857 45.374C37.9873 44.9639 37.1133 44.251 36.2637 43.2354L27.7822 33.0986C27.1963 32.376 26.5957 31.8682 25.9805 31.5752C25.375 31.2725 24.667 31.1211 23.8564 31.1211H20.8682C20.4092 31.1211 20.0283 30.9795 19.7256 30.6963C19.4326 30.4131 19.2861 30.0615 19.2861 29.6416Z"
          fill={
            focused && !shuffle
              ? theme.palette.new.playerButton
              : shuffle
                ? theme.palette.tertiary.accentYellow
                : "white"
          }
          stroke={activeFocusedStroke}
          strokeWidth={activeFocusedStrokeWidth}
          strokeLinejoin="round"
        />
        {focused && shuffle && (
          <rect
            x="37.2"
            y="33.6"
            width="1.5"
            height="9.8"
            fill={theme.palette.tertiary.accentYellow}
            transform="translate(-5.1 2) rotate(45 39.3 35.7)"
          />
        )}
      </svg>
    </Box>
  )
}
